import SectionHeader from "./SectionHeader";
import { genres } from "@/mocks/manhwa";

export default function Genres() {
  return (
    <section id="genres" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <SectionHeader
        tag="内容分类"
        title="按题材浏览连载韩漫"
        desc="从奇幻冒险到恋爱日常，八大热门题材分类一目了然，根据你的追更口味快速找到下一部心头好。"
      />
      <div className="grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-5">
        {genres.map((g) => {
          const iconBox =
            g.accent === "primary"
              ? "bg-primary-100 text-primary-700 group-hover:bg-primary-500 group-hover:text-background-50"
              : g.accent === "accent"
                ? "bg-accent-100 text-accent-700 group-hover:bg-accent-500 group-hover:text-background-50"
                : "bg-secondary-100 text-secondary-700 group-hover:bg-secondary-500 group-hover:text-background-50";
          return (
            <a
              key={g.name}
              href="#updates"
              className="group flex flex-col rounded-2xl border border-background-200/70 bg-background-50 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200 md:p-6"
            >
              <span className={`inline-flex h-12 w-12 items-center justify-center rounded-xl transition-colors ${iconBox}`}>
                <i className={`${g.icon} text-2xl`}></i>
              </span>
              <div className="mt-4 flex items-center justify-between">
                <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">{g.name}</h3>
                <span className="text-xs text-foreground-400">{g.count} 部</span>
              </div>
              <p className="mt-1.5 text-xs leading-relaxed text-foreground-600 md:text-sm">{g.desc}</p>
            </a>
          );
        })}
      </div>
    </section>
  );
}